import React, { useState, useEffect } from "react";
import Layout from "web/components/Layout";
import { Helmet } from "react-helmet";
import { MainContainer, SpecItem, TabPanelWrapper, TableWrapper } from "./SpecificationStyled";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import { useHistory } from "react-router-dom";
import { getSpecFileDetailsV2 } from "redux/actions/auth";
import AlertModal from "web/components/AlertModal";

const PalletSpecification = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [response, setResponse] = useState();
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const [activeTab, setActiveTab] = useState(1);
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchMyAPI();
  }, []);

  const fetchMyAPI = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      let response = await dispatch(getSpecFileDetailsV2(token));
      if (response?.success) {
        setResponse(response?.data);
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const handleDownload = (file) => {
    const fileUrl =
      process.env.REACT_APP_API_URL + "/user/image/" + file;
    window.open(fileUrl);
  };

  // Sort firstPallet
  const sortedFirstPallet = response?.firstPallet && [...response?.firstPallet].sort((a, b) =>
    a.palletSizeName.localeCompare(b.palletSizeName)
  );

  // Sort oddSizePallet
  const sortedOddSizePallet = response?.oldSizePallet && [...response?.oldSizePallet].sort((a, b) =>
    a.palletTypeName.localeCompare(b.palletTypeName)
  );
  const groupedOddSizePallet = sortedOddSizePallet && sortedOddSizePallet.map((item) => item.palletTypeName)
  const groupedOddSizePalletList = Array.from(new Set(groupedOddSizePallet))

  // Sort euroPallet
  const sortedEuroPallet = response?.euroPallet && [...response?.euroPallet].sort((a, b) =>
    a.palletSizeName.localeCompare(b.palletSizeName)
  );
  const groupedEuroPallet = sortedEuroPallet && sortedEuroPallet.map((item) => item.palletSizeName)
  const groupedEuroPalletList = Array.from(new Set(groupedEuroPallet))
  const extractPalletSize = (palletSizeName) => {
    const sizeMatch = palletSizeName.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/);
    return sizeMatch ? `${sizeMatch[1]}x${sizeMatch[2]}` : palletSizeName;
  };

  return (
    <>
      <Helmet
        title="Detailed Information and Specifications for Pallets | PalletTrader"
      >
        <meta
          name="description"
          content="Detailed specifications for pallets. Find the necessary information you need, including dimensions, weight limits, materials, and other important details."
        />
        <meta name="robots" content="index,follow" />
        <link
          rel="canonical"
          href="https://www.pallettrader.com/specifications"
        />
      </Helmet>
      <Layout pageType="specifications" topBarViewMobile={"hide"}>
        {loaderVisible && <Spinner />}
        <MainContainer>
          <TableWrapper>
            <div>
              <div className="community-details-header seller">
                <div className="community-name">
                  <h4>Choose a category below to see the pallet specification sheets.</h4>
                </div>
              </div>
              <TabPanelWrapper>
                <div className="tab-buttons">
                  <button
                    className={`${activeTab === 1 ? "active" : ""}`}
                    onClick={() => handleTabClick(1)}
                  >
                    48x40 Pallets
                  </button>
                  <button
                    className={`${activeTab === 2 ? "active" : ""}`}
                    onClick={() => handleTabClick(2)}
                  >
                    Odd Size Pallets
                  </button>
                  <button
                    className={`${activeTab === 3 ? "active" : ""}`}
                    onClick={() => handleTabClick(3)}
                  >
                    Euro Pallets
                  </button>
                </div>
                <div className="tab-content">
                  {activeTab === 1 && (
                    <div className="row justify-content-center">
                      {sortedFirstPallet && sortedFirstPallet.map((item, index) => {
                        return item.palletTypeName !== "48x40 Block" && <div key={index} className="col-md-4 col-sm-6">
                          <SpecItem>
                            <div className="item-top">
                              <p>{item.palletTypeName}</p>
                              <p>{item.palletSizeName}</p>
                            </div>
                            <div className="item-bottom">
                              <div>
                                <p>Spec Sheet:</p>
                                <AiOutlineCloudDownload
                                  onClick={() =>
                                    handleDownload(item?.specSheetFile)
                                  }
                                />
                              </div>
                            </div>
                          </SpecItem>
                        </div>
                      })}
                      <div className="col-md-4 col-sm-6">
                        <SpecItem>
                          <div className="item-top">
                            <p>48x40 Block</p>
                            <p>Pallet</p>
                          </div>
                          <div className="item-bottom d-flex justify-content-between">
                            {
                              sortedFirstPallet && sortedFirstPallet.filter(p => p.palletTypeName === "48x40 Block")
                                .map((p) => {
                                  return <div className="d-flex align-items-center ps-2">
                                    <p>{(p.palletSizeName).replace("Pallet", "Spec Sheet")}: </p>
                                    <AiOutlineCloudDownload
                                      role="button"
                                      className="ps-2"
                                      onClick={() => {
                                        handleDownload(p?.specSheetFile)
                                      }}
                                    />
                                  </div>
                                })
                            }
                          </div>
                        </SpecItem>
                      </div>
                    </div>
                  )}
                  {activeTab === 2 && (
                    <div className="row justify-content-center">
                      {/* {sortedOddSizePallet && sortedOddSizePallet.map((item, index) => (
                        <div key={index} className="col-md-3 col-sm-6">
                          <SpecItem>
                            <div className="item-top">
                              <p>{item.palletTypeName}</p>
                              <p>{item.palletSizeName}</p>
                            </div>
                            <div className="item-bottom">
                              <p>Spec Sheet:</p>
                              <AiOutlineCloudDownload
                                onClick={() =>
                                  handleDownload(item?.specSheetFile)
                                }
                              />
                            </div>
                          </SpecItem>
                        </div>
                      ))} */}
                      {groupedOddSizePalletList && groupedOddSizePalletList.map((item) => (
                        <div key={item} className="col-md-4 col-sm-6">
                          <SpecItem>
                            <div className="item-top">
                              <p>{item}</p>
                              <p>Pallet</p>
                            </div>
                            <div className="item-bottom d-flex justify-content-between">
                              {
                                sortedOddSizePallet.filter(p => p.palletTypeName === item)
                                  .map((p) => {
                                    return <div className="d-flex align-items-center ps-2">
                                      <p>{(p.palletSizeName).replace("Pallet", "Spec Sheet")}: </p>
                                      <AiOutlineCloudDownload
                                        role="button"
                                        className="ps-2"
                                        onClick={() => {
                                          handleDownload(p?.specSheetFile)
                                        }}
                                      />
                                    </div>
                                  })
                              }
                            </div>
                          </SpecItem>
                        </div>
                      ))}

                    </div>
                  )}
                  {activeTab === 3 && (
                    <div className="row justify-content-center">
                      {/* {sortedEuroPallet && sortedEuroPallet.map((item, index) => (
                        <div key={index} className="col-md-3 col-sm-6">
                          <SpecItem>
                            <div className="item-top">
                              <p>{item.palletTypeName}</p>
                              <p>{item?.palletSizeName && extractPalletSize(item.palletSizeName)}</p>
                            </div>
                            <div className="item-bottom">
                              <div>
                                <p>Spec Sheet:</p>
                                <AiOutlineCloudDownload
                                  onClick={() =>
                                    handleDownload(item?.specSheetFile)
                                  }
                                />
                              </div>
                            </div>
                          </SpecItem>
                        </div>
                      ))} */}
                      {groupedEuroPalletList && groupedEuroPalletList.map((item) => (
                        <div key={item} className="col-md-4 col-sm-6">
                          <SpecItem>
                            <div className="item-top">
                              <p>{item && extractPalletSize(item)}</p>
                              <p>Pallet</p>
                            </div>
                            <div className="item-bottom d-flex justify-content-between">
                              {
                                sortedEuroPallet.filter(p => p.palletSizeName === item)
                                  .map((p) => {
                                    return <div className="d-flex align-items-center ps-2">
                                      <p>{(p.palletTypeName).replace("Euro Pallet", "Spec Sheet")}: </p>
                                      <AiOutlineCloudDownload
                                        role="button"
                                        className="ps-2"
                                        onClick={() => {
                                          handleDownload(p?.specSheetFile)
                                        }}
                                      />
                                    </div>
                                  })
                              }
                            </div>
                          </SpecItem>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </TabPanelWrapper>
            </div>
          </TableWrapper>
        </MainContainer>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=""
          content={modalContent}
          link={modalLink}
          callBackAlert={(val) => { }}
        />

      </Layout>
    </>
  );
};

export default PalletSpecification;
